import axios from "../../config/axiosConfig";

export const getPatientSubscriptions = async (status) => {
  return await axios
    .get(`/customer/subscriptionList?status=${status}`)
    .then((res) => res)
    .catch((err) => err);
};